import React, {memo} from 'react'
import { Switch, Redirect } from 'react-router-dom';
import RouterWithLayout from './LayoutSwitchComp/RouterWithLayout/RouterWithLayout'

import Dashboard from './Views/Dashboard/Dashboard';
import Clients from './Views/Clients/Clients';
import Settings from './Views/Settings/Settings';
import Products from './Views/Products/Products';
import Customers from './Views/Customers/Customers';
import FormikForm from './Views/FormikForm/FormikForm';
import StakeHolders from './Views/StakeHolders/StakeHolders'
import StakeHolderView from './Views/StakeHolders/StakeHolderView'
import StakeHolderEdit from './Views/StakeHolders/StakeHolderEdit'

import UiMaterialCompRoutes from './Views/UiComponents/UiMaterialCompRoutes';


import NotFound404 from './Views/NotFound404/NotFound404';
import Error500 from './Views/Error500/Error500';

import SignIn from './Views/SignIn/SignIn'
import SignUp from './Views/SignUp/SignUp'
import ForgotPassword from './Views/ForgotPassword/ForgotPassword'

import Main from './Layouts/Main/Main';
import Secondary from './Layouts/Secondary/Secondary';
import NoLayout from './Layouts/NoLayout/NoLayout'


export const routesArray=[
{
    component: Dashboard,
    layout: Main,
    path:"/dashboard"
},
{
    component: Clients,
    layout: Main,
    path:"/clients"
},
{
    component: Products,
    layout: Main,
    path:"/products"
},
{
    component: Customers,
    layout: Main,
    path:"/customers"
},
{
    component: StakeHolders,
    layout: Main,
    path:"/stakeholders"
},
{
    component: StakeHolderView,
    layout: Main,
    path:"/stakeholder/view/:id"
},
{
    component: StakeHolderEdit,
    layout: Main,
    path:"/stakeholder/edit/:id"
},
{
    component: FormikForm,
    layout: Main,
    path:"/formik-form"
},
...UiMaterialCompRoutes //imported UiMaterialCompRoutes with es6 spread ... operator
,
{
    component: Settings,
    layout: Main,
    path:"/settings",
},
{
    component: Settings,
    layout: Main,
    path:"/settings/:subRoutes",
},
{
    component: NotFound404,
    layout: Secondary,
    path:"/not-found"
},
{
    component: Error500,
    layout: Secondary,
    path:"/internal-error"
},
{
    component: SignIn,
    layout: NoLayout, //null
    path:"/signin"
},
{
    component: SignUp,
    layout: NoLayout, //null
    path:"/signup"
},
{
    component: ForgotPassword,
    layout: NoLayout, //null
    path:"/forgot-password"
}
]

const Routes =()=> {
    return (
        <div style={{height: '100%', 
        // background: 'green'
        }}>
            
            <Switch>
                
                <Redirect 
                exact
                from="/"
                to="/dashboard"/>

                <Redirect 
                exact
                from="/components"
                to="/components/appbar"/>

                <Redirect 
                exact
                from="/settings"
                to="/settings/settings1"/>

                {
                    routesArray.map(({component, layout, path, ...rest})=>(
                        <RouterWithLayout 
                        key={component}
                        component={component}
                        layout={layout}
                        path={path}

                        exact
                        />
                    ))
                }

                <Redirect
                to="/not-found"
                />

            </Switch>
        
        </div>
    )
}
export default memo(Routes)
